import { TableColumn } from "../../types";
import { WorkloadTableItem } from "../../../../mst/kinds/workload.helpers";

const capacityAiDefault = { id: "capacityAi", label: "Capacity AI" };
export function WorkloadCapacityAiColumn<TData extends WorkloadTableItem>(
  column: TableColumn<TData> = capacityAiDefault,
) {
  const preset: TableColumn<TData> = {
    ...capacityAiDefault,
    enableHide: true,
    hiddenByDefault: true,
    size: 140,
    cell: (p) => {
      const workload = p.row.original;

      return <span>{workload.capacityAi === true ? "Enabled" : workload.capacityAi === false ? "Disabled" : ""}</span>;
    },
  };
  return Object.assign(preset, column);
}
